import GridChart from "../../../components/Chart/GridChart";

const salesCharts = [
  { type: "line", method: "sales.daily" },
  { type: "bar", method: "sales.monthly" },
];

const SalesDash = () => {
  return <GridChart charts={salesCharts} />;
};

export default SalesDash;
